import api from './api';
import { fetchPage } from './pagedParams';

const roleService = {
  getAllRoles: async () => {
    const response = await api.get('/admin/roles');
    return response.data;
  },

  getActiveRoles: async () => {
    const response = await api.get('/admin/roles/active');
    return response.data;
  },

  getRoleById: async (id) => {
    const response = await api.get(`/admin/roles/${id}`);
    return response.data;
  },

  getRoleWithUsers: async (id) => {
    const response = await api.get(`/admin/roles/${id}/with-users`);
    return response.data;
  },

  createRole: async (roleData) => {
    const response = await api.post('/admin/roles', roleData);
    return response.data;
  },

  updateRole: async (id, roleData) => {
    const response = await api.put(`/admin/roles/${id}`, roleData);
    return response.data;
  },

  cloneRole: async (id, newName, newDisplayName) => {
    const response = await api.post(`/admin/roles/${id}/clone`, null, {
      params: { newName, newDisplayName }
    });
    return response.data;
  },

  toggleActive: async (id) => {
    const response = await api.patch(`/admin/roles/${id}/toggle-active`);
    return response.data;
  },

  deleteRole: async (id) => {
    await api.delete(`/admin/roles/${id}`);
  },

  // Server-side paged list (Spring Page) for the URL-driven DataTable.
  getRolesPage: (params) => fetchPage('/admin/roles/paged', params),

};

export default roleService;